import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import config from '../../config';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { Button } from "primereact/button";

function UpdateSettings() {
    const navigate = useNavigate();
    const [isFullWidth, setIsFullWidth] = useState();
    const [isFullWidthEvent, setIsFullWidthEvent] = useState();
    const [featuredVenue, setFeaturedVenue] = useState();
    const [featuredEvent, setFeaturedEvent] = useState();
    const [venues, setVenues] = useState([]);
    const [events, setEvents] = useState([]);

    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    const fetchVenues = async () => {
        try {
            const response = await axios.get(`${config.BASE_URL}/api/admin/get-venues`, { withCredentials: true });
            
            if(response.data){
                response?.data?.length > 0 && response.data.map(item => {
                    if(item.isFeatured){
                        setFeaturedVenue(item);
                    }
                });

                setVenues(response.data);
            }
    
        } catch (err) {
            console.log('Failed to fetch venues');
        }
    };

    const fetchEvents = async () => {
        try {
            const response = await axios.get(`${config.BASE_URL}/api/admin/get-events`, { withCredentials: true });
            
            if(response.data){
                response?.data?.length > 0 && response.data.map(item => {
                    if(item.isFeatured){
                        setFeaturedEvent(item);
                    }

                    if(item.isFullWidth){
                        setIsFullWidthEvent(item);
                    }
                });

                setEvents(response.data);
            }
    
        } catch (err) {
            console.log('Failed to fetch events');
        }
    };

    const fetchFullWidthVenue = async () => {
        try {
            const response = await axios.get(`${config.BASE_URL}/api/admin/get-full-width-venue`, { withCredentials: true });
            
            if(response.data){
                setIsFullWidth(response.data);
            }
    
        } catch (err) {
            console.log('Failed to fetch venues');
        }
    };

    const saveSettings = async () => {
        if(isFullWidth){
            const formData = new FormData();
            formData.append('isFullWidth', true);

            try {
                const response = await axios.put(`${config.BASE_URL}/api/admin/update-venue/${isFullWidth?._id}`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    withCredentials: true,
                });

                setSuccessMessage('Settings Updated!');
            } catch (err) {
                setError('Failed to update venue');
            }
        }

        if(featuredVenue){
            const formData = new FormData();
            formData.append('isFeatured', true);

            try {
                const response = await axios.put(`${config.BASE_URL}/api/admin/update-venue/${featuredVenue?._id}`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    withCredentials: true,
                });

                setSuccessMessage('Settings Updated!');
            } catch (err) {
                setError('Failed to update venue');
            }
        }

        if(featuredEvent){
            const formData = new FormData();
            formData.append('isFeatured', true);

            try {
                const response = await axios.put(`${config.BASE_URL}/api/admin/update-event/${featuredEvent?._id}`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    withCredentials: true,
                });

                setSuccessMessage('Settings Updated!');
            } catch (err) {
                setError('Failed to update event');
            }
        }

        if(isFullWidthEvent){
            const formData = new FormData();
            formData.append('isFullWidth', true);

            try {
                const response = await axios.put(`${config.BASE_URL}/api/admin/update-event/${isFullWidthEvent?._id}`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    withCredentials: true,
                });

                setSuccessMessage('Settings Updated!');
            } catch (err) {
                setError('Failed to update event');
            }
        }

        setTimeout(() => {
            setSuccessMessage("");
        }, 4000);
    }
    
    useEffect(() => {
          fetchVenues();
          fetchEvents();
          fetchFullWidthVenue();
    }, []);

    return (
        <div className="dashboard update_detail_wrap">
            <div className="container">
                <h1 className="dash_title">Settings</h1>

                <div className="add_field textareaField">
                  <h4>Select Full width Venue</h4>
                  <Dropdown 
                    value={isFullWidth} 
                    onChange={(e) => setIsFullWidth(e.value)} 
                    options={venues} 
                    optionLabel="title" 
                    placeholder="Select Venue" 
                    className="w-full md:w-14rem" 
                  />
                </div>

                <div className="add_field textareaField">
                  <h4>Select Full width Event</h4>
                  <Dropdown 
                    value={isFullWidthEvent} 
                    onChange={(e) => setIsFullWidthEvent(e.value)} 
                    options={events} 
                    optionLabel="title" 
                    placeholder="Select Event" 
                    className="w-full md:w-14rem" 
                  />
                </div>

                <br />
                <div className="add_field textareaField">
                  <h4>Select Featured Venue</h4>
                  <Dropdown 
                    value={featuredVenue} 
                    onChange={(e) => setFeaturedVenue(e.value)} 
                    options={venues} 
                    optionLabel="title" 
                    placeholder="Select Venue" 
                    className="w-full md:w-14rem" 
                  />
                </div>

                <br />

                <div className="add_field textareaField">
                  <h4>Select Featured Event</h4>
                  <Dropdown 
                    value={featuredEvent} 
                    onChange={(e) => setFeaturedEvent(e.value)} 
                    options={events} 
                    optionLabel="title" 
                    placeholder="Select Event" 
                    className="w-full md:w-14rem" 
                  />
                </div>

                {successMessage && <p className="success-message">{successMessage}</p>}
                {error && <p className="error-message">{error}</p>}

                <br />
                <Button onClick={saveSettings}>Save</Button>

                
            </div>
        </div>
    ); 
}

export default UpdateSettings;
